import dao from './dao';

export const { getItemById: getInviteByToken } = dao.selectors;
